import { useCallback } from 'react';

import { CheckboxTool, TextFieldTool, useAgentTweakable } from '@/features/copilot/agent-tweakable';

import type { RxFormApi } from '../model/types';

/**
 * RxWizard agent integration:
 * - registers agent-tweakable draft fields
 */
export function useRxWizardAgentIntegration(form: RxFormApi) {
  const values = form.state.values;

  // Text field setters - wrapped in useCallback to maintain stable references
  const setQuantity = useCallback((v: string) => form.setFieldValue('quantity', v), [form]);
  const setDirections = useCallback((v: string) => form.setFieldValue('directions', v), [form]);
  const setRefills = useCallback((v: string) => form.setFieldValue('refills', v), [form]);
  const setDaysSupply = useCallback((v: string) => form.setFieldValue('daysSupply', v), [form]);
  const setEffectiveDate = useCallback(
    (v: string) => form.setFieldValue('effectiveDate', v),
    [form]
  );
  const setPharmacyNotes = useCallback(
    (v: string) => form.setFieldValue('pharmacyNotes', v),
    [form]
  );
  const setComment = useCallback((v: string) => form.setFieldValue('comment', v), [form]);

  // Checkbox setters
  const setIsUrgent = useCallback((v: boolean) => form.setFieldValue('isUrgent', v), [form]);
  const setNoSubstitutions = useCallback(
    (v: boolean) => form.setFieldValue('noSubstitutions', v),
    [form]
  );

  // Register text fields
  useAgentTweakable(TextFieldTool, 'quantity', values.quantity ?? '', setQuantity);
  useAgentTweakable(TextFieldTool, 'directions', values.directions ?? '', setDirections);
  useAgentTweakable(TextFieldTool, 'refills', values.refills ?? '', setRefills);
  useAgentTweakable(TextFieldTool, 'daysSupply', values.daysSupply ?? '', setDaysSupply);
  useAgentTweakable(TextFieldTool, 'effectiveDate', values.effectiveDate ?? '', setEffectiveDate);
  useAgentTweakable(TextFieldTool, 'pharmacyNotes', values.pharmacyNotes ?? '', setPharmacyNotes);
  useAgentTweakable(TextFieldTool, 'comment', values.comment ?? '', setComment);

  // Register checkbox fields
  useAgentTweakable(CheckboxTool, 'isUrgent', values.isUrgent ?? false, setIsUrgent);
  useAgentTweakable(
    CheckboxTool,
    'noSubstitutions',
    values.noSubstitutions ?? false,
    setNoSubstitutions
  );
}
